import { render } from "./MultiSelectInput.vue?vue&type=template&id=6ed8b140"
import script from "./MultiSelectInput.vue?vue&type=script&lang=js"
export * from "./MultiSelectInput.vue?vue&type=script&lang=js"

import "./MultiSelectInput.vue?vue&type=style&index=0&id=6ed8b140&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__